import * as cardValidator from 'card-validator';

export const CREDIT_CARD_MIN_LENGTH = 13;
export const CREDIT_CARD_MAX_LENGTH = 19;

export function isValidCreditCardNumber(raw: string): boolean {
  const digits = (raw ?? '').replace(/\D/g, '');

  if (
    digits.length < CREDIT_CARD_MIN_LENGTH ||
    digits.length > CREDIT_CARD_MAX_LENGTH
  ) {
    return false;
  }

  return cardValidator.number(digits).isValid;
}
